/**
 * Summer Sale config — single source of truth for the seasonal promo.
 *
 * There is no discount code: sale prices are reduced directly in Stripe, so the
 * cards show the reduced price automatically. `percent` is used only for the
 * banner's "30% OFF" headline — keep it in sync with the Stripe price cuts.
 *
 * Adjust `start` / `end` to control when the banner shows. Dates are inclusive
 * of the start and exclusive of the end (local time).
 */
export const SUMMER_SALE = {
    percent: 30,
    start: new Date("2026-06-01T00:00:00"),
    // Sale ended early (was 2026-09-01). Remember the visuals only follow
    // these dates — the actual prices live in Stripe and are managed there.
    end: new Date("2026-08-25T00:00:00"),
};

export const isSummerSaleActive = () => {
    const now = new Date();
    return now >= SUMMER_SALE.start && now < SUMMER_SALE.end;
};

export default SUMMER_SALE;
